import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { BaseComponent } from "BaseComponent";
import { Row, Col } from "react-bootstrap";
import Swatch from "Swatch";
import { SketchPicker } from "react-color";
import { selectWebSwatch, updateWebThemeColors } from "BrandingAction";
import { updateUnsavedChanges } from "DashboardMenuAction";
import { IMAGE_PATH, BASE_IMAGES_URL, ACCESS_FILES_API_KEY } from "Constants";
import LocaleStrings from "Languages";

class WebColorTheme extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedColor: "",
      pickerVisible: false,
    };

    /*this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);*/
    this.onColorChange = this.onColorChange.bind(this);
  }

  /*componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }


  setWrapperRef(node) {
    this.wrapperRef = node;
  }


  handleClickOutside(event) {
    debugger;
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if(this.state.pickerVisible){
        this.openColorPicker();
      }
    }
  }*/

  renderSwatches() {
    const { colors } = this.props;

    return colors.map((colordata, id) => {
      return (
        <Swatch
          key={id}
          data={colordata}
          colors={colors}
          onCustomColorSelection={this.customColorSelection}
          onColorChange={this.onColorChange}
        />
      );
    });
  }

  onColorChange(newarr, newValue) {
    this.props.updateWebThemeColors(newarr);
    this.props.selectWebSwatch(newValue);
  }

  customColorSelection = () => {
    this.openColorPicker();
  };

  handleColorChange = ({ hex }) => {
    this.props.updateUnsavedChanges();
    var newValue = { ...this.props.activeWebColor, color: hex, selected: true };
    this.props.selectWebSwatch(newValue);
    var curarr = [...this.props.colors];
    curarr = curarr.splice(0, curarr.length - 1);
    curarr.push(newValue);
    this.props.updateWebThemeColors(curarr);
    this.setState({ selectedColor: _.toUpper(hex) });
  };

  closeWebPicker = () => {
    this.setState({ pickerVisible: false });
  };

  openColorPicker = () => {
    if (!this.state.pickerVisible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      pickerVisible: !prevState.pickerVisible,
    }));

    // this.setState({ pickerVisible: !this.state.pickerVisible });
  };

  handleOutsideClick = (e) => {
    if (!this.node.contains(e.target)) this.openColorPicker();
  };

  inputChangedHandler(event) {
    const value = event.target.value;
    this.setState({ selectedColor: value });
  }

  render() {
    var { selectedColor } = this.state;
    var { activeWebColor, pickedColor, webimageIcon, webimageCover } =
      this.props;

    var styleHidden = { display: "none" };
    if (activeWebColor.custom && activeWebColor.selected) {
      styleHidden = { display: "block" };
    }

    var { webicon, webcover } = this.props.brandingData;
    var eventIconPreviewUrl = "";
    var eventCoverPreviewUrl = "";

    if (webimageIcon) {
      eventIconPreviewUrl = webimageIcon;
    } else if (webicon) {
      eventIconPreviewUrl = `${BASE_IMAGES_URL}/${webicon}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    } else {
      eventIconPreviewUrl =
        "../../style/images/v2_icons/branding/branding_icon_placeholder.png";
    }

    if (webimageCover) {
      eventCoverPreviewUrl = webimageCover;
    } else if (webcover) {
      eventCoverPreviewUrl = `${BASE_IMAGES_URL}/${webcover}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    // let coverImage = eventCoverPreviewUrl ? eventCoverPreviewUrl : '';
    //let style = eventCoverPreviewUrl ? {background:pickedColor.color, backgroundImage: 'url('+ eventCoverPreviewUrl +')', backgroundSize: '441px 194px', backgroundPosition:'79px 25px'} : {};

    // let style= {background:pickedColor.color, backgroundImage: 'url('+ eventCoverPreviewUrl +')', backgroundSize: '441px 194px', backgroundRepeat: 'no-repeat', backgroundPosition:'79px 25px'};
    let style = { background: pickedColor.color };

    return (
      <div className="form-group form-div" style={{ padding: 16 }}>
        <div
          className="color-title container"
          style={{ fontWeight: 300, paddingLeft: 0 }}
        >
          {LocaleStrings.branding_color_theme}
          <img
            src="images/header-icons/infoicon.png"
            style={{ paddingLeft: 10, marginTop: -2, cursor: "pointer" }}
          ></img>
          <div className="overlay">
            <div className="text" style={{ marginLeft: 240 }}>
              Select a color from the palette or enter your own
            </div>
          </div>
        </div>
        <div className="color-subtitle">
          {LocaleStrings.branding_color_theme_subtitle1}
        </div>
        <div className="swatchContainer">{this.renderSwatches()}</div>
        <div
          ref={(node) => {
            this.node = node;
          }}
        >
          {this.state.pickerVisible && (
            <div className="picker-container">
              <img
                className="picker-close-button"
                src="../../style/images/v2_icons/circle_cross_solid.png"
                onClick={this.openColorPicker}
              />
              <SketchPicker
                color={selectedColor}
                onChangeComplete={this.handleColorChange}
              />
            </div>
          )}
        </div>
        <div className="webbranding-template-container">
          <div className="webbranding-cover-container">
            {eventCoverPreviewUrl ? <img src={eventCoverPreviewUrl} /> : null}
          </div>
          <img
            className="webbranding-cover-container-image"
            src="../../style/images/v2_icons/branding/webbranding_top_banner.png"
          />
          <div className="webbranding-body-image" style={style}>
            <img src="../../style/images/v2_icons/branding/webbranding_body.png" />
          </div>
          <div className="webbranding-icon-container">
            <img src={eventIconPreviewUrl} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var selectedColor = state.webthemeColors.filter(
    (color) => color.selected === true
  );
  if (selectedColor.length > 0) {
    selectedColor = selectedColor[0];
  }

  var activeWebColor = {};
  if (state.brandingWebColor.color) {
    activeWebColor = state.brandingWebColor.color;
  }
  return {
    brandingData: state.brandingData,
    session: state.session,
    activeWebColor,
    colors: state.webthemeColors,
    pickedColor: selectedColor,
    webimageCover: state.localWebImageCover,
    webimageIcon: state.localWebImageIcon,
    unsavedChanges: state.unsavedChanges,
  };
}

export default connect(
  mapStateToProps,
  { selectWebSwatch, updateWebThemeColors, updateUnsavedChanges },
  null,
  { forwardRef: true }
)(WebColorTheme);
